import { Subject } from 'rxjs';

export const OnRowClickSubject = new Subject();
